import React, { PropTypes } from 'react';
import { forEach, get, merge, omit } from 'lodash';
import TextField from '../../../../../../common/components/c_TextField';
import MaskedTextField from '../../../../../../common/components/c_MaskedTextField';
import DropDownMenu from '../../../../../../common/components/c_DropDownMenu';
import ProgressComponent from '../../../../../../common/components/C_ProgressComponent';
import { updateCountry } from '../../../../../../lib/users/updates';

export default class ContactInformation extends ProgressComponent {
  static propTypes = {
    user: PropTypes.object.isRequired,
    model: PropTypes.string.isRequired,
    staticData: PropTypes.object.isRequired,
    tempState: PropTypes.object.isRequired,
    errorUpdate: PropTypes.func.isRequired,
    validation: PropTypes.object.isRequired
  }

  static defaultProps = {
    user: {}
  }

  constructor(props, context) {
    super(props, context);

    this.state = {
      validation: Object.assign({},
        omit(props.validation,
          ['password', 'phoneNumber', 'title', 'foundUsVia', 'foundUsOther']))
    };
  }

  handleTextFieldAttributes(prop, label) {
    return {
      key: `${prop}_${this.props.user[prop] || label}`,
      defaultValue: get(this.props, `tempState.user.${prop}`, get(this.props, `user.${prop}`)),
      floatingLabelText: label,
      isDirty: get(this.state, `validation.${prop}.errors[0]`) ? true : false,
      errorText: get(this.state, `validation.${prop}.errors[0]`),
      onBlur: this.validateUpdate(this.props.model, prop, this.updateTempState)
    };
  }

  handleDropDownMenuUI(prop, staticDataProp, label) {
    return {
      value: get(this.props, `tempState.user.${prop}`, get(this.props, `user.${prop}`)),
      menuItems: this.props.staticData[staticDataProp],
      floatingLabelText: label,
      validation: this.props.validation[prop],
      onErrorChange: this.props.errorUpdate,
      onChange: this.validateUpdate(this.props.model, prop, this.updateTempState)
    };
  }

  handleCountryDropDown(prop, staticDataProp, label) {
    const attributes = this.handleDropDownMenuUI(prop, staticDataProp, label);
    attributes.onChange = this.validateUpdate(this.props.model, prop, this.handleCountryChange(attributes.menuItems));
    return attributes;
  }

  handleCountryChange(countryList) {
    return (model, field, event, value) => {
      const updateUserCountry = updateCountry(countryList);
      const user = updateUserCountry(value || event.target.value);
      this.updateTempState('user', null, {}, user);
    };
  }

  renderStateOrOtherCountry(state, props) {

    const country = get(props, 'tempState.user.country', get(props, 'user.country'));
    const { countryList } = get(props, 'staticData', {});
    const otherCountry = countryList.find(c => c.subElement === 'Other');

    if (otherCountry && country === otherCountry.id) {
      return (
        <TextField
          className='dropdown-wrapper countryOther'
          {...this.handleTextFieldAttributes('countryOther', 'Specify Country')}
        />
      );
    }

    return (
      <DropDownMenu
        className='state-dropdown'
        canAutoPosition='true'
        {...this.handleDropDownMenuUI('state', 'stateList', 'State')}
      />
    );
  }

  render() {
    return (
      <div className='application-section-container contact-information'>
        <div className='form-heading'>
          Contact Information
        </div>

        <div className='form-contents'>
          {/* personal */}
          <TextField
            {...this.handleTextFieldAttributes('firstName', 'First Name')}
          />
          <TextField
            optional
            {...this.handleTextFieldAttributes('middleName', 'Middle Name or Initial')}
          />
          <TextField
            {...this.handleTextFieldAttributes('lastName', 'Last Name')}
          />
          <TextField
            optional
            {...this.handleTextFieldAttributes('nickName', 'Nickname')}
          />
          <TextField
            disabled
            {...this.handleTextFieldAttributes('email', 'Email')}
          />
          <DropDownMenu
            style={{}}
            {...this.handleDropDownMenuUI('bestContactTime', 'bestContactTimeList', 'What is the best time to call you?')}
          />

          {/* phone numbers */}
          <div className='phone-number-container'>
            <MaskedTextField
              data-id='Phone Number 1'
              mask='(999) 999-9999'
              hideMaskChar
              className='phone-number'
              {...this.handleTextFieldAttributes('phoneNumber1', 'Preferred Phone Number')}
            />
            <DropDownMenu
              className='phone-number-type'
              {...this.handleDropDownMenuUI('phoneType1', 'phoneTypeList')}
            />
          </div>
          <div className='phone-number-container'>
            <MaskedTextField
              data-id='Phone Number 2'
              mask='(999) 999-9999'
              hideMaskChar
              optional
              className='phone-number'
              {...this.handleTextFieldAttributes('phoneNumber2', 'Phone Number')}
            />
            <DropDownMenu
              className='phone-number-type'
              {...this.handleDropDownMenuUI('phoneType2', 'phoneTypeList')}
            />
          </div>
          <div className='phone-number-container'>
            <MaskedTextField
              data-id='Phone Number 3'
              mask='(999) 999-9999'
              hideMaskChar
              optional
              className='phone-number'
              {...this.handleTextFieldAttributes('phoneNumber3', 'Phone Number')}
            />
            <DropDownMenu
              className='phone-number-type'
              {...this.handleDropDownMenuUI('phoneType3', 'phoneTypeList')}
            />
          </div>

          {/* location */}
          <div className='location-container'>
            <DropDownMenu
              className='country-dropdown'
              {...this.handleCountryDropDown('country', 'countryList', 'Country of Residence')}
            />
            {
              this.renderStateOrOtherCountry(this.state, this.props)
            }
            <DropDownMenu
              className='timezone-dropdown'
              canAutoPosition='true'
              {...this.handleDropDownMenuUI('timezone', 'timezoneList', 'Time Zone')}
            />
          </div>
          <div className='fields-container'>
            <TextField
              className='address'
              {...this.handleTextFieldAttributes('address', 'Address Line 1')}
            />
            <TextField
              className='city'
              maxLength='60'
              {...this.handleTextFieldAttributes('city', 'City')}
            />
          </div>
          <div className='fields-container'>
            <TextField
              className='address'
              {...this.handleTextFieldAttributes('address2', 'Address Line 2')}
            />
            <MaskedTextField
              data-id='Zip'
              hideMaskChar
              mask='99999'
              className='zip'
              {...this.handleTextFieldAttributes('zip', 'Zip')}
            />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/r_ApplicantDashboard/f_Application/r_ApplicationForm/Profile/c_ContactInformation/index.js